import React, { ReactElement } from 'react';

import { Link, LinkProps } from '@capintel/component-lib/link';
import { useNavigate } from 'react-router-dom-v5-compat';

type Props = Omit<LinkProps, 'href'> & {
  to: string;
  replace?: boolean;
};

export default function LinkReactRouter({ to, replace, children, ...rest }: Props): ReactElement {
  const navigate = useNavigate();

  return (
    <Link
      {...rest}
      href={to}
      onClick={e => {
        e.preventDefault();
        navigate(to, { replace });
      }}
    >
      {children}
    </Link>
  );
}
